module.exports = __webpack_public_path__ + "images/emoji/u7533.78a7403e602f23ddcd9e.png";